import type { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';

import { BrowserLink } from '@mopla/ui';

export interface IFooterBrowserLinkProps extends TypographyProps<'div'> {
	url: string;
}

export const FooterBrowserLink: FC<IFooterBrowserLinkProps> = ({
	url,
	children,
	...typographyProps
}) => {
	return (
		<Typography
			variant="l1"
			component="div"
			color="solutions.700"
			sx={{
				userSelect: 'none',
				'& a': { textDecoration: 'none' },
			}}
			{...typographyProps}
		>
			<BrowserLink url={url}>{children}</BrowserLink>
		</Typography>
	);
};
